import React, {Component} from "react";
import CmModal from "../CmModal/CmModal";
import CmTree from "../CmTree/CmTree";
import "./treeSelectModal.css";
import {Icon} from "antd";

export default class TreeSelectModal extends Component {
    static defaultProps = {
        isEnable:true,
        disableKeys:[],
        defaultBtnType:'inputBtn',//textBtn
    };
    static propTypes = {};
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }

    render() {
        const {
            title,

            valueList,
            treeData,

            autoExpandParent,
            onExpand,
            expandedKeys,

            disableKeys,
            checkable,
            onCheck,
            checkedKeys,
            checkStrictly,
            defaultBtnType,
            showIcon,
            placeholder = "请选择所属部门",
            disableAllDept,
            onDisableAllDeptCall
        } = this.props;

        const {
            visible
        } = this.state;
        let currentBtn='';
        if(defaultBtnType=='inputBtn'){
            currentBtn=<div className="value-select-wrap" onClick={() => this.showModal()}>
                {
                    valueList.length ?
                        valueList.map(item => {
                            return (
                                <span className="value-select-item" key={item.value}>
                                        {item.label}
                                    <span className="close-btn" onClick={e => {
                                        e.stopPropagation();
                                        this.onItemDelete(item.value);
                                    }}>
                                            <svg viewBox="64 64 896 896" focusable="false" className=""
                                                 data-icon="close"
                                                 width="1em"
                                                 height="1em" fill="currentColor" aria-hidden="true">
                                                <path
                                                    d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"/>
                                            </svg>
                                        </span>
                                    </span>
                            );
                        }) :
                        <div className="value-select-placeholder">{placeholder}</div>
                }
                <div className="arrow-right">
                    <Icon type="right"/>
                </div>
            </div>
        }else if(defaultBtnType=='textBtn'){
            currentBtn=<span onClick={() => this.showModal()}>绑定部门</span>
        }
        return (
            <>
                {currentBtn}
                <CmModal
                    visible={visible}
                    title={title}
                    handleCancel={() => {
                        this.setState({visible: false});
                    }}
                    maskClosable={defaultBtnType=='textBtn'?true:false}
                    centered={true}
                    handleOk={this.handleOk}
                    width={400}
                >
                    <div style={{height: 360}}>
                        <CmTree
                            disableKeys={disableKeys}
                            visible={visible}
                            treeData={treeData}
                            onExpand={onExpand}
                            expandedKeys={expandedKeys}
                            showIcon={showIcon}
                            autoExpandParent={autoExpandParent}
                            checkStrictly={checkStrictly}
                            checkable={checkable}
                            onCheck={(a, e, c) => onCheck(a, e, c)}
                            checkedKeys={checkedKeys}
                            selectable={false}
                            isSearch={this.props.isSearch}
                            showSearch={this.props.showSearch}
                            disableAllDept={disableAllDept}//除了admin，其他禁用"全部"部门
                            onDisableAllDeptCall={onDisableAllDeptCall}
                        />
                    </div>
                    <style>
                        {`.cm-scrollbars > div:nth-child(3){
                             margin-bottom: -8px;
                         `}
                    </style>
                </CmModal>
            </>
        );
    }

    showModal = () => {
        if(this.props.isEnable){
            this.props.showModalHandle();
            this.setState({
                visible: true
            });
        }
    };

    handleOk = () => {
        this.props.handleOk();
        this.setState({visible: false});
    };

    onItemDelete = id => {
        this.props.onItemDelete && this.props.onItemDelete(id);
    };

}

